module.exports = {
  //大首页
  活动详情: "Detail",
  //运转活动
  "与火车迷同行，发现更多精彩": "Travel with train fans and discover more",
  我发布的活动: "My Activities",
  我要发布: "Create",
  近期活动: "Recent",
  历史活动: "History",
  活动地点: "Location",
  主办方: "Organizer",
  加载更多: "Load More",
  暂无数据: "No Data",
  修改: "Edit",
  驳回原因: "Reason",
  待审核: "Pending",
  已通过: "Approved",
  已驳回: "Rejected",
  编辑: "Edit",
  添加: "Add",
  活动名称: "Activity name",
  主办方名称: "Organizer",
  主办方头像: "Organizer Icon",
  删除: "Delete",
  举办城市: "City",
  详细地点: "Location",
  开始时间: "startTime",
  结束时间: "endTime",
  封面图: "Cover Img",
  正文: "Content",
  联系人姓名: "Contact Name",
  联系人电话: "Contact Phone",
  联系人微信: "Contact Wechat",
  联系人邮箱: "Contact Email",
  我们将与您联系核实相关事宜: "We will contact with you to confirm details",
  提交审核: "Submit",
  取消: "Cancel",
  文件不得大于2MB: "File should not larger than 2MB",
  "请在桌面端打开网站发布哦~": "Please open the website on the desktop to publish it.",
  "尊敬的火车迷，您好！": "Dear train fans, hello!",
  "为弘扬火车文化，Dreamrail追梦铁道的活动版块将为您提供免费的活动发布服务，您可以在这里发布您组织的火车活动，让更多的火车迷参与到活动中来！": "To promote train culture, Dreamrail's activity section will provide you with free activity publishing services. You can publish your organized train activities here and let more train fans participate!",
  "请您认真阅读以下信息，稍后在您提交信息后，我们将尽快审核，审核通过后将在Dreamrail火车迷社区首页展示您的活动预告。": "Please read the following information carefully. After you submit the information, we will review it as soon as possible. Once approved, your activity preview will be displayed on the homepage of the Dreamrail train fan community.",
  "注意事项：": "Notes:",
  "请确保您为活动的组织者和负责人，在您提交申请后，我们将会与你联系核实相关事宜。": "Please ensure that you are the organizer and person in charge of the activity. After you submit the application, we will contact you to verify the relevant matters.",
  "活动内容请务必真实有效，不得发布虚假信息。": "The content of the activity must be true and valid, and no false information shall be published.",
  "请确保您上传的图片清晰，不得包含违规内容。": "Please ensure that the images you upload are clear and do not contain any illegal content.",
  "活动内容您可以按照提供的模板填写，包括活动介绍、活动亮点、活动要求、报名方式、报名费用、注意事项等。越是详细的活动内容，用户越是能够积极的参与到您的活动报名中来。": "You can fill in the activity content according to the provided template, including activity introduction, activity highlights, activity requirements, registration method, registration fee, precautions, etc. The more detailed the activity content, the more actively users can participate in your activity registration.",
  "活动审核通过后，我们将会在Dreamrail火车迷社区首页展示您的活动，您可以在“活动”板块查看您发布的活动。您可以编辑和修改您发布的活动，任何修改都需要重新审核": "After the activity is approved, we will display your activity on the homepage of the Dreamrail train fan community. You can view your published activities in the 'Activity' section. You can edit and modify your published activities, and any modifications need to be re-reviewed.",
  "在Dreamrail上发布活动信息是完全免费的，我们不会收取任何费用。我们不会干涉您具体的活动内容与方式。另外，您可能需要自行处理报名费用的收取、建群等事宜。": "Publishing activity information on Dreamrail is completely free, and we will not charge any fees. We will not interfere with your specific activity content and methods. In addition, you may need to handle matters such as collecting registration fees and building groups by yourself.",
  "Dreamrail可以为您提供一些活动物料的支持（比如纪念品、海报定制），以及场地的联络等服务，如果您需要，请主动提出，我们将竭诚为您服务！": "Dreamrail can provide you with some support for activity materials (such as souvenirs, poster customization), as well as venue contact services. If you need it, please actively propose it, and we will serve you wholeheartedly!",
  "我同意以上内容，开始填写": "I agree to the above content and start filling in",
  // header组件
  关于我们: "About",
  首页: "Home",
  注册: "Register",
  登录: "Login",
  退出登录: "Logout",
  火车币: "RailCoin",
  火车券: "RailVoucher",
  我的火车券: "My RailVoucher",
  去兑换: "Redeem Now",
  请先验证您的邮箱哦: "Please verify your email first",
  商店: "Store",
  关于: "About",
  合作: "Cooperate",
  运转和活动: "Activity",
  DIY头像: "Avatar",
  铁路查询: "Railsearch",
  我的行驶里程: "My Mileage",
  公里: "km",
  账户设置: "Settings",
  个人中心: "User Center",
  //footer
  与我们合作: "Cooperate",
  //login
  "注册 Dreamrail": "Register",
  请输入您的邮箱: "email",
  请输入您的密码: "password",
  "请输入您的密码，不少于6位": "password, no less than 6 characters",
  我同意: "I agree with ",
  "Dreamrail团队的服务条款、隐私政策": "Dreamrail User Service Agreement",
  创建账户: "Create an account",
  成为新用户: "Register",
  "已有账户？": "Already have an account?",
  立即登录: "Login Now",
  登录Dreamrail: "Login",
  忘记密码: "Forget password",
  请检查您的邮箱并点击链接激活账号哦: "Please verify your email",
  重新发送邮件: "resend verify email",
  "邮箱验证成功！即将跳转...": "Email verified! Redirecting ...",
  立即进入: "Enter now",
  发送邮件: "Send Email",
  "验证邮件已发送，请前往邮箱查看并修改密码": "Verification email has been sent, please go to your mailbox to check and change your password",
  请输入有效的邮箱: "Please enter a valid email address",
  登录成功: "Login successful",
  邮箱或密码错误: "Email or password incorrect",
  请输入有效的邮箱: "Please enter a valid email address",
  注册成功: "Registration successful",
  邮箱已存在: "Email already exists",
  邮件已发送: "Email sent",
  "邮箱验证链接已经发至您邮箱：": "The verification link has been sent to your email:",
  "请点击邮件中的验证链接，激活账号": "Please click the verification link in the email to activate your account",
  "等待验证...": "Waiting for verification...",
  "邮件验证成功，点击登入网站": "Verification success, login now",
  "没有收到邮件？": "Didn't receive the email?",
  "1.检查您有相中的垃圾箱；": "1. Check your spam folder;",
  "2.若仍然没有找到邮件，请尝试": "2. If you still can't find the email, try",
  重新发送: "resending",
  找回密码: "Forgot password",
  //identity
  "剩余{time}s": "{time}s",
  先来设置你的身份吧: "Let's set your identity first",
  更换头像: "Change avatar",
  昵称: "Nickname",
  每2个月内只能修改一次: "Can only modify once every 2 months",
  绑定手机号: "Bind phone number",
  请输入昵称: "Please enter a nickname",
  请输入手机号: "Please enter a phone number",
  请输入验证码: "Please enter the verification code",
  获取验证码: "Get verification code",
  完成: "Complete",
  //profile
  个人资料: "Profile",
  账号设置: "Account",
  密码设置: "Password",
  性别: "Gender",
  一旦设定不可更改: "Once set, cannot be changed",
  生日: "Birthday",
  男: "Male",
  女: "Female",
  所在地: "Location",
  职业: "Occupation",
  个人描述: "Description",
  请输入所在地: "Please enter your location",
  请输入职业: "Please enter your occupation",
  保存: "Save",
  更改: "Change",
  账号注销: "Account cancellation",
  "注销账号后所有数据将会被销毁并不可找回，请谨慎操作": "After delete the account, all data will be destroyed and cannot be recovered. Please operate carefully",
  注销账号: "Unregist",
  重置密码: "Reset password",
  "真的要注销账号吗？该操作不可恢复": "Are you sure you want to delete your account? This operation cannot be undone.",
  "即将向您的注册邮箱发送重置邮件，注意查收": "A reset email will be sent to your registered email address, please check it.",
  //method
  请稍候: "Loading",
  请登录: "Please login first",
  //home
  制作壁纸数量: "Created",
  制作独一无二的: "Create Unique",
  火车壁纸: "Wallpapers",
  "在这里，200 多款中国火车及 100多款国外火车任您挑选，总有一款符合您现在的感受": "There are more than 200 Chinese trains and more than 100 world trains for you to choose from. There is always one that suits your current feelings.",
  立即体验: "DIY Wallpaper",

  查看大家的作品: "Inspire Me",
  //topbar
  DIY自己的火车壁纸: "DIY your own wallpaper",
  我的壁纸: "My wallpaper",
  制作壁纸: "DIY Now",
  //square
  "欢迎来到 Dreamrail！特送 DIY 壁纸免费券一张，邀您体验！": "Welcome to Dreamrail! We are giving you a free RailVoucher for DIY!",
  立即使用: "Use now",
  大家的作品: "Everyone's Works",
  我也做一张: "Create From This",
  搜索车型名称: "Search Train",
  车型许愿: "Didn't find the train you want?",
  告诉我你想要的车型: "Tell us the train you want",
  请输入车型: "Enter the train name",
  提交: "Submit",
  再做一张: "Make Another",
  立即尝鲜: "Try Now",
  免费尝鲜券: "Try for Free",
  //draw
  请选择要制作的风格: "Choose a style",
  场景风格: "Scene",
  贴纸风格: "Sticker",
  日历风格: "Calendar",
  宽高比: "Ratio ",
  退出DIY: "Exit",
  "壁纸分辨率：": "Resolution: ",
  "DIY 壁纸": "DIY Wallpaper",
  存草稿: "Save Draft",
  无水印: "no watermark",
  购买: "Buy Now",
  下载: "Download",
  免费下载: "Download",
  搜索车型: "Search Name",
  请选择国家: "Choose Country",
  请选择动力: "Choose Power",
  请选择类型: "Choose Type",
  背景: "Background",
  全部动力: "All Power",
  蒸汽机车: "Steam",
  内燃机车: "Diesel",
  电力机车: "Electric",
  动车组: "EMU",
  车厢: "Coach",
  最近使用: "Recent",
  全部类型: "All Types",
  全部国家: "All Countries",
  全部背景: "All backgrounds",
  线性渐变: "Linear gradient",
  径向渐变: "Radial gradient",
  纯色: "Solid color",
  图案: "Pattern",
  无: "None",
  放到左侧: "Left",
  放到右侧: "Right",
  放到两侧: "Both",
  拼命加载中: "Loading",
  草丛: "Grass",
  树木: "Tree",
  花朵: "Flower",
  山: "Mountain",
  森林: "Forest",
  建筑: "Buildings",
  天气: "Weather",
  空白: "Empty",
  您还没有选择车辆哦: "You haven't selected a train yet",
  保存失败: "Save failed",
  上传失败: "Upload failed",
  保存成功: "Saved successfully",
  请先登录再制作壁纸哦: "Please login before creating wallpaper",
  "加载中...": "Loading...",
  水牌样式: "Board Style",
  水牌信息: "Board Info",
  出发站: "Departure",
  出发站拼音: "Departure Subtitle",
  到达站: "Arrival",
  到达站拼音: "Arrival Subtitle",
  车次: "Train No.",
  车辆类型: "Type",
  点击编辑: "Edit",
  自动获取拼音: "Auto Generate Subtitles",
  "日历风格 --2": "Calendar Style",
  插画: "Illustration",
  摄影作品: "Photography",
  请选择日期: "Choose Date",
  上个月: "Prev Mon",
  下个月: "Next Mon",
  当前: "Now",
  日历尺寸: "Calendar Size",
  大: "L",
  中: "M",
  小: "S",
  无: "None",
  您还没有选择背景图片哦: "You haven't selected a background image yet",
  //finishingdialog
  正在保存草稿: "Saving draft",
  正在为您准备订单: "Preparing your order",
  马上就好: "Just a moment",
  订单详情: "Order Detail",
  取消订单: "Cancel Order",
  "购买成功后您将不能再次编辑这张壁纸，但可以无限次下载文件。壁纸仅供个人欣赏使用，不得用于任何商业用途。": "",
  分辨率: "Resolution",
  金额: "Price",
  DIY免费券: "Free RailVoucher",
  微信支付: "WeChat Pay",
  "PayPal支付(只支持账单地址不在中国的银行卡)": "PayPal - Only if your billing address is not in China",
  支付宝支付: "Alipay",
  实付金额: "Actual amount",
  我已知晓并同意: "I know and agree ",
  立即购买: "Buy Now",
  "《Dreamrail销售协议》": "Dreamrail Sales Agreement",
  "订单编号：": "Order Number:",
  "请于10分钟内完成支付，如有问题请联系客服": "Please complete the payment within 10 minutes. If you have any questions, please contact customer service.",
  更换支付方式: "Back",
  "我已完成支付，查看订单": "Check the order",
  "即将打开微信进行支付，如有问题请联系管理员": "WeChat will be opened for payment. If you have any questions, please contact the administrator",
  请点击PayPal按钮来支付: "Please click the PayPal button to pay",
  "{freeTicketCount}张": "{freeTicketCount} left",
  "确定要退出吗?": "Are you sure you want to exit?",
  确定: "confirm",
  取消: "cancel",
  //slider
  拖动滑块来移动地面哦: "Drag the slider to move the ground",
  //orderlist draftList
  我的壁纸: "My Wallpaper",
  草稿箱: "My Draft",
  我的订单: "My Order",
  编辑: "Edit",
  待支付: "WAITING",
  已支付: "PAID",
  已关闭: "CLOESD",
  已退款: "REFUNDED",
  查看订单: "View order",
  空空如也: "Empty",
  DIY手机壁纸: "Phone Wallpaper",
  DIY桌面壁纸: "Desktop Wallpaper",
  数字壁纸: "Digital Wallpaper",
  搜索车型名称: "Search train",
  "真的要删除这条草稿吗？删除后不可恢复": "Do you really want to delete this draft? Deletion is irreversible.",
  提示: "Hint",
  草稿已删除: "Draft deleted",
  "DIY 壁纸订单": "DIY Wallpapers",
  商店订单: "Store Orders",

  //orderdetail
  "Dreamrail DIY壁纸": "Dreamrail Wallpaper",
  复制: "copy",
  关闭订单: "Cancel Order",
  立即支付: "Pay Now",
  再做一张: "DIY Another",
  使用手机扫描二维码: "Scan the QR code",
  长按图片即可保存到手机: "Long press the image to save",
  发送到手机: "Send to phone",
  查看原图: "Original image",
  继续编辑: "Edit",
  "真的要关闭这个订单吗？": "Do you really want to close this order?",
  订单已关闭: "Order closed",
  "暂不支持，请关闭订单后点击“重新编辑”并下单": 'Not supported yet, please close the order and click "Edit" to replace the order',
  实付款: "Actual payment",
  下单时间: "Order time",
  支付时间: "Pay time",
  支付渠道: "Payment channels",
  DIY免费券: "DIY Wallpaper Free RailVoucher",
  微信扫码支付: "WeChat",
  微信H5支付: "WeChat",
  订单金额: "Order amount",
  优惠券减免: "Voucher discount",
  尝鲜券: "Trial Voucher",
  下载文件: "Download",
  //sharedialog
  "向好友展示你的壁纸吧！": "Share with your friends!",
  手机扫描二维码查看分享海报: "Scan the QR code to view the shared poster",
  保存海报: "Save Poster",
  复制分享链接: "Copy Share Link",
  已将分享链接复制到剪贴板: "Link Copied",
  //paysuccess
  支付成功: "Pay Success",
  立即前往订单详情: "Go to order detail",
  "感谢购买及支持！特送火车币一枚": "Thank you for your purchase! A RailCoin has been added to your wallet.",
  下载壁纸: "Download",
  分享作品: "Share",
  //wallet
  我的火车币: "RailCoin",
  我的火车券: "RailVoucher",
  枚: "RailCoin",
  可兑换的火车券: "RailVoucher avalible",
  去使用: "Use now",
  立即兑换: "Redeem",
  免费尝鲜券: "Trial Voucher",
  //paydialog
  请使用微信扫码完成支付: "Please use WeChat to scan the QR code",
  我已完成支付: "I have paid",
  //getcoupondialog
  "您要兑换的火车券为：": "The train ticket you want to redeem is:",
  优惠券有效期至: "Coupon valid until",
  优惠券有效期: "Coupon validity period",
  消耗数量: "Consumption quantity",
  取消: "Cancel",
  确认: "Confirm",
  兑换火车券: "Redeem RailVoucher",
  //downloaddialog
  "使用手机扫描二维码，长按即可保存壁纸": "Scan the QR code and long press to save the wallpaper",
  下载到本地: "Download now",
  //about
  关于我们: "About",
  做世界优秀火车文化的传播者: "To be the disseminator of the world's excellent train culture",
  "火车爱好者的幸福之地，助力火车文化相关企业、铁路公司的成长和发展，让更多的人可以热爱并参与到火车文化": "A happy place for train lovers, helping the growth and development of train culture-related enterprises and railway companies, so that more people can love and participate in train culture",
  //cooperate
  联系我们: "Conntact",
  "我们真诚的欢迎您与我们联系，希望通过紧密的合作能够让彼此成长，实现共赢": "We sincerely welcome you to contact us and hope that through close cooperation we can grow together and achieve a win-win situation.",
  //home
  免费获得: "Free",
  热门商品: "Hot",
  "你的RailStyle，你来定义": "Your RailStyle, you define it",
  "您购买的商品属于数字商品，购买成功后将不能退款，但可以无限次重复下载该文件。本站提供的所有数字商品仅供个人欣赏使用，不得用于任何商业用途。": "The product you purchased is a digital product. You will not be able to get a refund after the purchase is successful, but you can download the file repeatedly as many times as you want. All digital products provided by this site are for personal enjoyment only and may not be used for any commercial purpose.",
  //giftcodedialog
  礼品码兑换: "Redeem Gift Code",
  "一个礼品码限使用一次，可以兑换Dreamrail火车券": "A gift code can be used once to redeem Dreamrail RailVouchers",
  "在您购买实体商品时可以获得一个礼品码，如无法使用请联系客服": "You can get a gift code when you purchase physical goods. If you cannot use it, please contact customer service",
  "部分活动会释出礼品码，请随时关注Dreamrail社交媒体账号活动信息": "Some activities will release gift codes, please pay attention to the activity information of Dreamrail social media account",
  请输入礼品码: "Enter code",
  立即兑换: "Redeem",
  "礼品码兑换成功！": "Redeem Success! ",
  立即查看我的火车券: "Check my RailVoucher",
  请输入礼品码: "Enter code",
  到期: "Expires",
  "一大波新品即将上新...": "New products coming soon...",
  这个debug用: "For debug",
  选择月: "Select Month",
  分享链接: "Share Link",
  复制: "Copy",
  分享二维码: "Share QR Code",
  圆形头像预览: "Circular Avatar Preview",
  我的头像: "My Avatar",
  制作头像: "Create Avatar",
  请先登录再制作头像哦: "Please login before creating avatar",
  制作头像数量: "Created Avatars"
};
